import type React from "react";

interface ShareableLinkExportCardProps {
  disabledReason: string;
}

export default function ShareableLinkExportCard({ disabledReason }: ShareableLinkExportCardProps) {
  return (
    <div
      className="Card"
      style={
        {
          "--card-color": "var(--color-primary)",
          "--card-color-darker": "var(--color-primary-darker)",
          "--card-color-darkest": "var(--color-primary-darkest)",
        } as React.CSSProperties
      }
      data-testid="shareable-link-export-card"
    >
      <div className="Card-icon">{linkIcon}</div>
      <h2>Shareable link</h2>
      <div className="Card-details">{disabledReason}</div>
      <button
        type="button"
        className="Card-button ToolIcon ToolIcon_type_button ToolIcon_size_medium ToolIcon_type_button--show"
        aria-label="Shareable link"
        disabled
      >
        <div className="ToolIcon__label">Shareable link</div>
      </button>
    </div>
  );
}

const linkIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);
